<template>  
    <div>
        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des réservations d'articles
        </div>

        <div class="ix-table-box ix-absence-table-box" v-if="!loading">
            <div class="d-flex justify-content-start ml-2 mb-2 mt-2 booking-filter-btns btn-group-custom">
                <button class="btn filter-btn-group filter-btn-group-left" :class="{ active: currentPeriod === PERIOD_WEEK }" @click="getData(PERIOD_WEEK)">Semaine</button>
                <button class="btn filter-btn-group filter-btn-group-right" :class="{ active: currentPeriod === PERIOD_MONTH }" @click="getData(PERIOD_MONTH)">Mensuel</button>
            </div>
            <table :class="['ix-absence-table', 'ix-checkings', { 'compact-cells': isMonthView , 'custom-cells': !isMonthView }]">  
                <thead>
                    <tr>
                        <th class="ix-absence-table-empty-cell text-center">
                            <a :href="urlPrevious" class="ix-absence-table-navigation-button">
                                <i class="far fa-angle-left"></i>
                            </a>
                            <a :href="urlNext" class="ix-absence-table-navigation-button">
                                <i class="far fa-angle-right"></i>
                            </a>
                        </th>
                        <th v-for="(month, index) in table.months" :key="index" :colspan="month.span + 1" class="ix-absence-cell-month">
                            {{ month.label }} {{ month.year }}
                        </th>
                    </tr>
                    <tr>
                    <th class="ix-absence-table-empty-cell"></th>
                        <th v-for="(week, index) in table.weeks" :key="index" :colspan="week.span + 1" class="ix-absence-cell-week">
                            <span>S{{ week.number }}</span>
                        </th>
                    </tr>
                    <tr>
                        <th class="ix-absence-table-empty-cell">
                        </th>
                        <th v-for="(day, index) in table.days" :key="index" class="ix-absence-cell-day" v-bind:class="{ 'ix-absence-cell-weekend': day.is_weekend, 'ix-absence-cell-not-working': day.is_not_working, 'ix-absence-cell-today': day.is_today }">
                            <span class="ix-triangle-indicator" v-if="day.is_today"></span>
                            {{ day.label }} <br>
                            {{ day.day }}
                        </th>
                        <th class="ix-absence-cell-day">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, dataIndex) in table.data" :key="dataIndex">
                        <td v-if="row.article">
                            <a :href="row.article.url" class="ix-link-normal">
                                <span v-if="row.article.number">{{ row.article.number }} </span>
                                {{ row.article.name }}
                            </a>
                        </td>
                        <td v-for="(day, dayIndex) in row.days" class="ix-absence-cell" :key="dayIndex">
                            <div v-if="day.article_bookings">
                                <a
                                    :href="articleBooking.url"
                                    class="ix-checking-card trigger-sidebar text-center booking-article-hover booking-article-btn"
                                    style="font-size: 0.8rem !important;"
                                    :class="{ 'center-icon': isMonthView }"
                                    type="button"
                                    v-for="(articleBooking, articleBookingIndex) in day.article_bookings"
                                    :key="articleBookingIndex"
                                    :title="isMonthView ? (articleBooking.booking.number + ' : ' + articleBooking.order.number + (articleBooking.order.designation  ? ' - ' + articleBooking.order.designation  : '') + (articleBooking.booked_quantity ? ('\n↓ ' + articleBooking.booked_quantity) : '')) : ''"
                                >
                                    <template v-if="isMonthView">
                                        <span class="d-flex align-items-center justify-content-center booking-article-icon">
                                            <i class="fas fa-box"></i>
                                        </span>
                                    </template>
                                    <template v-else>
                                        {{ articleBooking.booking.number }} : {{ articleBooking.order.number }}<br>
                                        {{ articleBooking.order.designation }}
                                        <span class="d-block ix-text-bold text-danger" v-if="articleBooking.booked_quantity">
                                            <i class="fas fa-arrow-down"></i> {{ articleBooking.booked_quantity }}
                                        </span>
                                    </template>
                                </a>
                            </div>
                        </td>
                        <td class="ix-absence-cell text-center font-weight-bold">
                            {{ getRowBookingSum(row) }}
                        </td>
                    </tr>
                    <tr v-if="table.data.length == 0">
                        <td></td>
                        <td :colspan="table.days.length" class="text-center">
                        <span>Il n'y a pas de réservations d'articles durant la période demandée</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

export default {
    name: 'BookingArticleTable',
    props : {
            admin : Number,
            url : String,
            orderRoute: String,
            nextUrl: String,
            previousUrl: String,
            articleBookingIdToOpen: String,
            period: Number,
        },
    data() {
        return {
            loading : true,
            table : {
                    days: [],
                    weeks: [],
                    months: [],
                    data: []
            },
            selectedArticleBooking: null,
            urlPrevious: this.previousUrl,
            urlNext: this.nextUrl,

            PERIOD_WEEK : 1,
            PERIOD_MONTH : 2,
            currentPeriod: this.period,
        }
    },
    computed: {
        isMonthView() {
            return this.currentPeriod === this.PERIOD_MONTH;
        }
    },
    methods : {
        openArticleBooking: function(articleBookingId){
            this.selectedArticleBooking = null
            this.selectedArticleBooking = articleBookingId
        },
        getRowBookingSum(row) {
            let sum = 0;
            if (row.days) {
                for (const day of row.days) {
                    if (day.article_bookings) {
                        for (const booking of day.article_bookings) {
                            if (booking.booked_quantity) {
                                sum += Number(booking.booked_quantity);
                            }
                        }
                    }
                }
            }
            return sum > 0 ? sum : '';
        },
        getTotalBookingSum() {
            let sum = 0;
            for (let dayIndex = 0; dayIndex < this.table.days.length; dayIndex++) {
                sum += Number(this.getDayBookingSum(dayIndex) || 0);
            }
            return sum > 0 ? sum : '';
        },
        async getData(period){
            this.loading = true;
            this.currentPeriod = period;
            let url = this.url;
            // On récupère les paramètres existants
            let params = new URLSearchParams(window.location.search);
            // On met à jour le paramètre period
            if (period == this.PERIOD_WEEK) {
                params.set('period', 'week');
            } else if (period == this.PERIOD_MONTH) {
                params.set('period', 'month');
            }
            fetch(url + '?' + params.toString(), {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.table.days = data.days
                        this.table.weeks = data.weeks
                        this.table.months = data.months
                        this.table.data = data.data
                        this.urlPrevious = data.previousUrl
                        this.urlNext = data.nextUrl
                    })
                }
            }).catch(error => {
                this.loading = false;
                console.log(error)
            });
        },
    },
    mounted(){
        this.getData(this.currentPeriod);
    }
}
</script>

<style scoped>

.booking-article-hover {
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(93, 141, 247, 0.10);
    border: none;
    padding: 8px 10px;
    margin-bottom: 4px;
    margin-right: 4px;
    font-size: 0.95rem;
    background: #e3edfc;
    color: #2d3a4a;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;
    cursor: pointer;
    outline: none;
}
.booking-article-hover:hover {
    background-color: #3566c7;
    color: #fff;
    box-shadow: 0 2px 8px rgba(53, 102, 199, 0.18);
}
.btn-group-custom {
    display: flex;
    gap: 0;
}
.filter-btn-group {
    background: transparent;
    border: 1px solid #5d8df7;
    color: #5d8df7;
    font-weight: 600;
    font-size: 1rem;
    padding: 7px 18px;
    box-shadow: none;
    border-radius: 0;
    transition: background 0.2s, color 0.2s, border 0.2s;
    margin: 0;
}
.filter-btn-group-left {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border-right: none;
}
.filter-btn-group-right {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}
.filter-btn-group:hover, .filter-btn-group:focus {
    background: #5d8df7;
    color: #fff;
    border-color: #5d8df7;
}
.filter-btn-group.active, .filter-btn-group.active:hover, .filter-btn-group.active:focus {
    background: #5d8df7;
    color: #fff;
    border-color: #5d8df7;
    z-index: 1;
}
.compact-cells th,
.compact-cells td {
    padding: 2px 4px !important;
    font-size: 0.85em !important;
    min-width: 24px;
    max-width: 40px;
}
.custom-cells th,
.custom-cells td {
    padding: 2px 4px !important;
    font-size: 0.85em !important;
    min-width: 180px;
    max-width: 180px;
}

.booking-article-btn {
    
    min-width: 32px;
    min-height: 32px;
    padding: 0;
}
.booking-article-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1em;
}
.center-icon {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>